import styles from './ProductTab.module.scss';
import { Table } from 'reactstrap';
import SectionTable from '../../../global/Components/Scrollspy/ScrollspyContent/Sections/SectionTable';

export default function ProductFeatures(props) {
  return (
    <>
    {
        props.features.length > 0 &&
            <>
                <div id={`product-features`}>
                    <h3 className={`py-4`}>Product Features</h3>
                    <div  className={`${styles.tableWrap} ms-2 mx-sm-4 mb-4`}>
                        <Table striped className={`mb-0 ${styles.lgtTable}`}>
                            <tbody>
                                {
                                    props.features.map((feature,i) => (
                                        <SectionTable key={feature.value+i} data={feature} />
                                        )
                                    )
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </>
    }
    </>
  )
}
